import { ColorMap } from "./colormaps";

const REMAP_GROUP = new Set<ColorMap>([
  ColorMap.VIRIDIS,
  ColorMap.TURBO,
  ColorMap.MAGMA,
  ColorMap.INFERNO,
  ColorMap.GRAYSCALE,
]);

const LIGHT_CEILING = 0.9;
// On the near-black dark canvas, the lowest colormap stops (magma/inferno start
// near-black, viridis dark blue, etc.) vanish. Instead of throwing away the low
// end of the ramp, we keep the full ramp and lift its OKLCH lightness so the
// darkest stops become a visible, same-hue lighter shade. This is the minimum
// output lightness (in OKLab L) the darkest stop is raised to.
const DARK_LIGHT_FLOOR = 0.4;

/**
 * Colormap sampling domain per theme. On light canvases the bright top of the
 * ramp washes out on white, so cap it; dark canvases keep the full domain (the
 * dark end is handled by the lightness lift below, not by dropping range).
 */
export function getColormapDomain(colorMap: ColorMap, isDark: boolean): { lo: number; hi: number } {
  if (!REMAP_GROUP.has(colorMap)) return { lo: 0, hi: 1 };
  return isDark ? { lo: 0, hi: 1 } : { lo: 0, hi: LIGHT_CEILING };
}

/**
 * OKLab lightness floor for the colormap on this theme. `0` means no lift.
 * Dark canvases lift the darkest stops off the near-black background while
 * preserving hue/chroma; light canvases need no lift.
 */
export function getColormapLightFloor(colorMap: ColorMap, isDark: boolean): number {
  return isDark && REMAP_GROUP.has(colorMap) ? DARK_LIGHT_FLOOR : 0;
}
